import { createContext, useContext } from 'react';

/**
 * The indexes of rows whose cells must not be edited, for a table whose owner decides that per row
 * (Product Masterdata locks a product once it is marked for deletion). Cells read it through
 * `useIsReadonly`, so no cell type has to know about it.
 *
 * A context rather than a value on the row: a cell only re-renders for row data when its `memo`
 * comparator allows it (`TextCell`'s does not), and rows only pick up form changes after the
 * table's debounce. A context change reaches every cell at once.
 *
 * No provider means nothing is locked, which is every table but that one.
 */
export const LockedRowsContext = createContext<ReadonlySet<number> | null>(null);

export const useIsRowLocked = (rowIndex: number): boolean => useContext(LockedRowsContext)?.has(rowIndex) ?? false;
